import { connect } from 'react-redux'
import BoardView from './components/BoardView'
import { boardDefLoad } from '../../store/boardDef'
import { boardDefsLoad } from '../../store/boardDefs'
import { tasksLoad, taskMove } from '../../store/tasks'
import { taskAddStart, taskAddCancel, taskAddSave } from '../../store/addTask'
import { getFilter, UNASSIGNED_FILTER_ADD } from '../../store/taskFilter'
import { projectLoad } from '../../store/project'
import { projectMembersLoad } from '../../store/projectMembers'

const isBoardsLoaded = (state) => {
  return state &&
    state.boardDef &&
    state.boardDefs &&
    state.boardDefs[state.boardDef] &&
    state.taskMappings &&
    state.project &&
    state.tasks &&
    state.projectMembers &&
    state.taskFilter[state.project.id]
}

const mapStateToProps = (state, ownProps) => {
  if (!isBoardsLoaded(state)) {
    return { isLoaded: false }
  }

  const projectId = state.project.id
  const taskFilter = getFilter(state.taskFilter[projectId])
  return {
    isLoaded: true,
    boardDef: state.boardDefs[state.boardDef],
    project: state.project,
    isAddingTask: state.addTask.isAdding,
    isFilteredView: state.taskFilter[projectId].isOn,
    tasks: state.boardDefs[state.boardDef].swimlanes.reduce((map, lane) => {
      map[lane.id] = taskFilter(
        (state.taskMappings[lane.id] || []).map(taskId => (state.tasks[taskId]))
      )
      return map
    }, {})
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  loadBoardData: () => {
    dispatch(boardDefsLoad())
    dispatch(boardDefLoad(ownProps.params.id))
    dispatch(tasksLoad(ownProps.params.id))
    dispatch(projectLoad(ownProps.params.id))
    dispatch(projectMembersLoad(ownProps.params.id))
  },
  onCardDrop: (taskPosition) => { dispatch(taskMove(taskPosition)) },
  onCardAdd: () => { dispatch(taskAddStart()) },
  taskAddCancel: () => { dispatch(taskAddCancel()) },
  taskAddSave: (taskName, addAnotherTask, laneId) => {
    dispatch(taskAddSave(taskName, addAnotherTask, laneId))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(BoardView)



// WEBPACK FOOTER //
// ./src/routes/Board/index.js